function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 59.538,
    viewBox: "0 0 58 59.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 310",
    style: {
      fill: "transparent"
    },
    d: "M0 0h58v58H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9516"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 3954",
    d: "M0 0h53.983v11H0z",
    transform: "translate(2.051 10)",
    style: {
      fill: "#3d55dc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 110"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 108"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 107"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 106"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 126",
    d: "M-515.656 10.915V7.928h-3.717v2.987h-6.939V7.928h-3.717v2.987h-6.939V7.928h-3.718v2.987h-6.939V7.928h-3.717v2.987H-562v52.248h57V10.915zm6.939 48.531h-49.565v-32.83h49.565v32.83zm0-36.547h-49.565v-8.267h6.939v2.986h3.717v-2.986h6.939v2.986h3.717v-2.986h6.939v2.986h3.717v-2.986h6.939v2.986h3.717v-2.986h6.939V22.9z",
    transform: "translate(562.001 -3.625)",
    style: {
      fill: "#343953"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 109"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 127",
    d: "M-400.154 256.549h1.635a2.3 2.3 0 0 0 1.73-.584 2.139 2.139 0 0 0 .562-1.55 1.892 1.892 0 0 0-.557-1.454 2.161 2.161 0 0 0-1.534-.52 2.263 2.263 0 0 0-1.476.483 1.544 1.544 0 0 0-.594 1.258h-3.068a3.771 3.771 0 0 1 .653-2.171 4.348 4.348 0 0 1 1.826-1.5 6.093 6.093 0 0 1 2.585-.541 5.781 5.781 0 0 1 3.843 1.173 4 4 0 0 1 1.39 3.232 3.254 3.254 0 0 1-.647 1.953 4.211 4.211 0 0 1-1.7 1.369 3.841 3.841 0 0 1 1.948 1.4 3.8 3.8 0 0 1 .642 2.208 4.068 4.068 0 0 1-1.5 3.3 6.04 6.04 0 0 1-3.975 1.242 5.726 5.726 0 0 1-3.784-1.221 3.987 3.987 0 0 1-1.47-3.227h3.068a1.777 1.777 0 0 0 .653 1.422 2.406 2.406 0 0 0 1.608.552 2.416 2.416 0 0 0 1.714-.578 2 2 0 0 0 .621-1.534q0-2.314-2.548-2.314h-1.624z",
    transform: "translate(420.356 -219.073)",
    style: {
      fill: "#343953"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 128",
    d: "M-287.2 259.246a7.83 7.83 0 0 1-1.327 4.9 4.632 4.632 0 0 1-3.885 1.7 4.664 4.664 0 0 1-3.864-1.667 7.6 7.6 0 0 1-1.369-4.777v-2.842a7.726 7.726 0 0 1 1.343-4.915 4.666 4.666 0 0 1 3.869-1.677 4.671 4.671 0 0 1 3.864 1.661 7.577 7.577 0 0 1 1.369 4.771zm-3.068-3.128a5.664 5.664 0 0 0-.525-2.8 1.776 1.776 0 0 0-1.64-.877 1.744 1.744 0 0 0-1.6.834 5.3 5.3 0 0 0-.547 2.608v3.761a5.94 5.94 0 0 0 .515 2.811 1.752 1.752 0 0 0 1.651.919 1.723 1.723 0 0 0 1.624-.882 5.8 5.8 0 0 0 .52-2.7z",
    transform: "translate(327.162 -219.073)",
    style: {
      fill: "#343953"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonth);
export default __webpack_public_path__ + "static/media/month.afb3a1a7.svg";
export { ForwardRef as ReactComponent };